import { render, staticRenderFns } from "./Normas.vue?vue&type=template&id=06660272&"
import script from "./Normas.vue?vue&type=script&lang=js&"
export * from "./Normas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports